<template>
<!--关于我们-->
  <div class="aboutUs">
    <div class="imgBox">
      <img :src="itemData.content.boxImg.urlData" class="imgBox_img">
    </div>
    <div class="productMenu">

      <el-menu :default-active="menuIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item  v-for="item in itemData.content.menuData" :index="item.num.content" :indexPath="item.path.content">{{item.tital.content}}</el-menu-item>
      </el-menu>

    </div>
<!--    <div class="member">-->
<!--      <div class="member_1">-->
<!--        <div class="member_content">-->
<!--          <div class="member_content_left">-->
<!--            <div class="member_content_left_1">-->
<!--              <div class="member_content_left_1_1">-->
<!--                CEO-->
<!--              </div>-->
<!--              <div class="member_content_left_1_2">-->
<!--                张三-->
<!--              </div>-->
<!--              <div class="member_content_left_1_3">-->
<!--                核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="member_content_right">-->
<!--            <div class="member_content_img">-->

<!--            <img :src="itemData.content.boxImg.urlData" class="member_content_right_img">-->
<!--              </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="member_content">-->
<!--          <div class="member_content2_left">-->
<!--            <div class="member_content_img">-->
<!--            <img :src="itemData.content.boxImg.urlData" class="member_content_right_img">-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="member_content2_right">-->
<!--            <div class="member_content_left_1">-->
<!--              <div class="member_content_left_1_1">-->
<!--                CEO-->
<!--              </div>-->
<!--              <div class="member_content_left_1_2">-->
<!--                张三-->
<!--              </div>-->
<!--              <div class="member_content_left_1_3">-->
<!--                核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心关键标题的内容描述，核心-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="vision" v-show="itemData.content.yuanj.showData">-->
<!--      <div class="vision1">-->
<!--        <div class="vision_content">-->
<!--          <div class="vision_content_1">-->
<!--            {{itemData.content.yuanj.text1.content }}-->
<!--          </div>-->
<!--          <div class="vision_content_2">-->
<!--            {{itemData.content.yuanj.text2.content }}-->
<!--          </div>-->
<!--          <div class="vision_content_3">-->
<!--            <div class="vision_content_3_img">-->
<!--              <img :src="itemData.content.yuanj.text3.content" class="vision_content_3_img_1">-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="timeAxis" v-show="itemData.content.courseData.showData">
      <div class="timeAxis1">
        <div class="timeAxisContent">
          <el-timeline>
            <el-timeline-item placement="top" v-for="item in itemData.content.courseData.itemData" color="#0A54D6">
              <div class="timelineContent" v-if="item.url.content == ''">
                <div class="timelineContent_1">
                  {{item.text1.content}}
                </div>
                <div class="timelineContent_2">
                  {{item.text2.content}}
                </div>
                <div class="timelineContent_3">
                  {{item.text3.content}}
                </div>
              </div>

              <div class="timelineContent2"  v-if="item.url.content != ''">
                <div class="timelineContent_left">
                  <div class="timelineContent_left1">
                  <div class="timelineContent_left_1">
                    {{item.text1.content}}
                  </div>
                  <div class="timelineContent_left_2">
                    {{item.text2.content}}
                  </div>
                  <div class="timelineContent_left_3">
                    {{item.text3.content}}
                  </div>
                  </div>
                </div>
                <div class="timelineContent_right">
                  <div class="timelineContent_right_1">
                    <img :src=" item.url.content" class="timelineContent_right_img">
                  </div>
                </div>

              </div>
            </el-timeline-item>

          </el-timeline>
        </div>
      </div>
    </div>

    <div class="contentBox" v-show="itemData.content.c3Data.showData" >
      <div class="contentBoxItem"  >
      <div class="count_3">
        <p class="c3_p1" v-for="item in itemData.content.c3Data.c3P">{{item.text1}}</p>
      </div>
      <div class="count3">
        <div class="p4" v-for="item in itemData.content.c3Data.c3w" >
          <div class="p_top">
            <div class="sp1">{{item.text1}}</div>
            <div class="sp2">{{item.text2}}</div>
          </div>
          <div class="p_buttom">
            <div class="sp3">{{item.text3}}</div>
          </div>
        </div>
      </div>
      <div class="c3_img" v-for="itemall in itemData.content.c3Data.c3Img">
        <div class="c3_img2" v-for="item in  itemall.imgItem">

          <img :src="item.url" class="c3_imgg">
          <p v-if="item.text1 != ''" class="c3_p2">{{item.text1}}</p>
        </div>
      </div>
      </div>
    </div>


  </div>
</template>

<script>
import {Data} from "./js/aboutUs";

export default {
  name: "aboutUs",
  data() {
    return {
      dataAll:Data,
      itemData:{},
      imageHeight: "596px",
      screenWidth:0,
      menuIndex:"1",
      videoUrl2:"http://116.62.38.250//image/nr/jjfa/11.mp4",
      urlData:""
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }
    that.setWH();
    that.initBox()
    window.addEventListener('resize', this.setWH);


  },
  methods:{
    setWH() {
      let that = this;
      that.screenWidth = window.innerWidth;
      console.log("hh"+that.screenWidth);

      let hight = that.screenWidth /1440 *596;
      console.log("hh"+hight);
      that.imageHeight = hight + "px";
    },
    initBox(){
      let that = this;
      let path = that.urlData;
      if(path == ""  || path == undefined){
        that.menuIndex = "1";
        that.itemData.content.courseData.showData = true;
        that.itemData.content.c3Data.showData = false;
      } else if(path == "bt1"){
        that.menuIndex = "1";
          that.itemData.content.courseData.showData = true;
        that.itemData.content.c3Data.showData = false;
      } else if(path == "bt2"){
        that.menuIndex = "2";
          that.itemData.content.courseData.showData = false;
        that.itemData.content.c3Data.showData = true;
      } else {
        that.menuIndex = "1";
          that.itemData.content.courseData.showData = true;
        that.itemData.content.c3Data.showData = false;
      }
    },
    handleSelect(index,path){
      let that = this;
      if(index == "1"){
        that.menuIndex = "1";
          that.itemData.content.courseData.showData = true;
        that.itemData.content.c3Data.showData = false;
      } else if(index == "2"){
        that.menuIndex = "2";
          that.itemData.content.courseData.showData = false;
        that.itemData.content.c3Data.showData = true;
      } else {
        that.menuIndex = "1";
        that.itemData.content.courseData.showData = true;
        that.itemData.content.c3Data.showData = false;
      }
    }
  }
  ,
  beforeDestroy() {
    window.removeEventListener('resize', this.setWH); // 移除监听器
  }
}
</script>

<style scoped>
.sp2{
  font-family: SourceHanSansCN;
  font-size: 40px;
  color: #63B62E;
  letter-spacing: 0.86px;
  text-align: justify;
}
.sp3{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: center;
}
.sp1{
  font-family: SourceHanSansCN;
  font-size: 100px;
  color: #63B62E;
  letter-spacing: 2.14px;
  text-align: justify;
}

.c3_imgg{
  width: 100%;
  aspect-ratio: 376/483;
}
.p4{
  width: 171px;
  height: 180px;
  margin-right: 100px;
}
.p_top{
  display: flex;
}
.count3{
  display: flex;
  margin-top: 100px;
}
.contentBoxItem{
  width: 78%;
}
.contentBox{
  width: 100%;
  display: flex;
  justify-content: center;
}
.c3_img2{
  width: 31.5%;
  margin-right: 15px;
}
.c3_img{
  width: 100%;
  display: flex;
  margin-top: 50px;
}
.count_3{
  width: 100%;
  height: 125px;
}
.c3_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: center;
}
.c3_p1{
  font-family: SourceHanSansCN;
  font-size: 18px;
  letter-spacing: 0.39px;
  text-align: left;
  margin-top: 10px;
}
.timelineContent_right_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.timelineContent_right_1{
  width: 100%;
  padding-top: 62.71%;
  position: relative;

}
.timelineContent_right{
  width: 53.44%;
}
.timelineContent_left_3{

  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 16px;
}
.timelineContent_left_2{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 28px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 8px;
}
.timelineContent_left_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #0A54D6;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.timelineContent_left1{
  width: 93.33%;
}
.timelineContent_left{
  width: 55.56%;
}
.timelineContent_3{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
}
.timelineContent_2{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 28px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 8px;
}
.timelineContent_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #0A54D6;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.timelineContent2{
  width: 100%;
  display: flex;
  margin-bottom: 100px;
}
.timelineContent{
  width: 100%;
  margin-bottom: 100px;
}
.timeAxisContent{
  width: 100%;
}
.timeAxis1{
  width: 77.78%;
}
.timeAxis{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #FFFFFF;
  margin-bottom: 100px;
}
.vision_content_3_img_1{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.vision_content_3_img{
  width: 100%;
  padding-top: 50%;
  position: relative;
  margin-top: 40px;
}
.vision_content_2{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.vision_content_1{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #0A54D6;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.vision_content{
  width: 100%;
}
.vision1{
  width: 77.78%;
}
.vision{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #FFFFFF;
  margin-bottom: 100px;
}
.member_content_img{
  width: 100%;
  padding-top: 100%;
  position: relative;
}
.member_content2_right{
  width: 57.14%;
  display: flex;
  align-items: center;
  justify-content: right;
}
.member_content2_left{
  width: 42.86%;
}
.member_content_right_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.member_content_left_1_3{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 16px;
}
.member_content_left_1_2{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 28px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 8px;
}
.member_content_left_1_1{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #0A54D6;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.member_content_left_1{
  width: 87.5%;
}
.member_content_left{
  width: 57.14%;
  display: flex;
  align-items: center;


}
.member_content_right{
  width: 42.86%;

}
.member_content{
  width: 100%;
  display: flex;
  margin-top: 68px;
}

.member_1{
  width: 77.78%;
}
.member{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 56px;
  margin-bottom: 68px;
}

.imgBox_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.imgBox{
  width: 100%;
  padding-top: 41.39%;
  position: relative;
}
.aboutUs{
  background: #FFFFFF;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue